import genericApi from './genericApi';

import ApiResponse from '../models/ApiResponse';
import AccountTransaction from '../models/AccountTransaction';
import ForwarderGhaInvoiceBalance from '../models/ForwarderGhaInvoiceBalance';

const invoiceReqHandler = {

  getWalletBalance: (id: number): Promise<ApiResponse<ForwarderGhaInvoiceBalance>> => {

    return genericApi.get(`wallet/${id}`);
  },

  setWallet: (fwdId: number, transaction: AccountTransaction) : Promise<ApiResponse<boolean>> => {
    return genericApi.post(`wallet/${fwdId}`, transaction);
  },
};

export default invoiceReqHandler;